import { render, staticRenderFns } from "./HistoryBalance.vue?vue&type=template&id=11921e68&scoped=true&"
import script from "./HistoryBalance.vue?vue&type=script&lang=js&"
export * from "./HistoryBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11921e68",
  null
  
)

export default component.exports